module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    class: {
      'uk-form-blank': _vm.blank,
      'uk-form-width-large': _vm.size == 'large',
        'uk-form-width-medium': _vm.size == 'medium',
        'uk-form-width-small': _vm.size == 'small',
        'uk-form-width-mini': _vm.size == 'mini',
        'uk-width-1-1': _vm.size == 'full',
        'uk-form-success': _vm.color == 'success',
        'uk-form-danger': _vm.color == 'danger'
    },
    attrs: {
      "type": _vm.type
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d4bcee2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkInput.vue
// module id = 286
// module chunks = 2